const promises = [
    {
        name: "Verzekerd van resultaat",
        description:
            "Bij Personal Training Uden en Schijndel van WE ARE beloven we onze leden resultaat. Wanneer je geen resultaat hebt krijg je jouw investering terug! In alle jaren we actief zijn in de Personal Training hebben we nog nooit meegemaakt dat onze leden geen resultaat hebben. Bij ons ben je dus verzekerd van resultaat!",
        icon: "/assets/icons/trophy.svg",
    },
    {
        name: "Trainen in een ruimte met gelijkgestemden",
        description:
            "Op beide locaties komt je terecht in een warm bad. Zowel bij Personal Training Uden als Schijndel wordt je begeleidt door ervaringsdeskundige die zelf ook ooit geworsteld hebben met hun fysiek en mentale weerbaarheid. Onze Personal Trainers weten dus waar je doorheen gaat! Om de reden laten we alleen leden toe die op vergelijkbare wijze worstelen met zichzelf waardoor je traint in een ruimte met gelijkgestemden.",
        icon: "/assets/icons/handshake.svg",
    },
    {
        name: "Onbeperkt nazorg",
        description:
            "Personal Training Uden en Schijndel van WE ARE heeft op beide locaties een private gym. Dit biedt de mogelijkheid om na je transformatie bij ons te blijven trainen zodat je het warme bad niet hoeft te verlaten. Onder begeleiding van onze Personal Trainers zorgen we er samen voor dat je de behaalde resultaten kan behalen en je niet in het jojo-effect terecht komt.",
        icon: "/assets/icons/dumbbell.svg",
    },
];

export default ({ classNames = "" }) => {
    return (
        <div
            className={`relative xs:pt-8 sm:pt-8 md:pt-16 lg:pt-16 ${classNames}`}
        >
            <div className="absolute inset-0">
                <div className="bg-black h-1/3 sm:h-2/3" />
            </div>
            <div className="relative max-w-7xl mx-auto">
                <div className="text-center">
                    <p className="text-8xl tracking-tight font-extrabold italic uppercase font-custom text-white sm:text-8xl md:text-8xl lg:text-8xl xl:text-8xl">
                        <span className="text-we-are-yellow">We </span>
                        <span className="text-we-are-purple">Are</span>
                    </p>
                    <h2 className="block text-white font-custom italic font-bold uppercase xl:inline  xs:text-4xl sm:text-4xl md:text-4xl lg:text-5xl">
                        Promising
                    </h2>
                </div>
                <div className="lg:mt-24 md:mt-12 sm:mt-12 xs:mt-12 max-w-lg mx-auto grid gap-5 lg:grid-cols-3 lg:max-w-none">
                    {promises.map((promise, key) => (
                        <div
                            key={key}
                            className="flex flex-col rounded-lg shadow-lg overflow-hidden"
                        >
                            <div className="flex-shrink-0">
                                <img
                                    className="h-24 w-1/2 mx-auto"
                                    src={promise.icon}
                                    alt="Personal training Uden en Schijndel"
                                />
                            </div>
                            <div className="flex-1 bg-black p-6 flex flex-col justify-between">
                                <div className="flex-1">
                                    <div className="block mt-2">
                                        <p className="text-xl font-bold text-center text-gray-100">
                                            {promise.name}
                                        </p>
                                        <p className="text-lg text-center mt-2 text-gray-100">
                                            {promise.description}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};
